function PPPage() {
    return (
      <div className="bg-tertiary text-left px-16 py-10">
          <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
          <p className="mb-4"><strong>Last Updated: 04/03/2024</strong></p>
  
          <h2 className="text-xl font-semibold mb-2">Introduction</h2>
          <p className="mb-4">
          At Train Rex, we respect your privacy and are committed to handling your personal data responsibly. This Privacy Policy outlines how we collect, use, and protect your personal data when you use our mobile application ("App") and our related services.
          </p>
  
          {/* Other sections go here */}
          {/* You can break down your Privacy Policy into different sections using headings and paragraphs */}
  
          <h2 className="text-xl font-semibold mb-2">Scope</h2>
          <p className="mb-4">
          This Privacy Policy applies solely to the personal data collected via our App and does not cover any external services linked from our App. We encourage you to review the privacy policies of any third-party services you choose to use.
          </p>
    
             {/* Collection of Personal Data */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Collection of Personal Data</h2>
          <p>
            When you use our App, we may collect the following types of personal data:
          </p>
          <ul className="list-disc ml-8 mb-4">
            <li>Contact Information: Names, email addresses, telephone numbers, postal addresses, and social media handles.</li>
            <li>Health and Fitness Information: Weight, height, body measurements, workout routines, nutrition preferences, and health goals.</li>
            <li>Payment Information: Credit card details, billing addresses, and transaction histories.</li>
            <li>Usage Data: Device type, operating system, IP address, browser type, referring/exit pages, and clickstream data.</li>
            <li>Communications: Records of conversations, emails, and messages exchanged with our customer support teams.</li>
          </ul>
          <p>We may also collect personal data from third-party sources, such as social media platforms, if you choose to link your Train Rex account to those platforms.</p>
        </div>

        {/* Purposes of Processing */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Purposes of Processing</h2>
          <p>
            Your personal data may be processed for the following purposes:
          </p>
          <ul className="list-disc ml-8 mb-4">
            <li>Providing you with our services</li>
            <li>Offering personalized diet and training plans</li>
            <li>Managing your account and communication with you</li>
            <li>Improving our App and services</li>
            <li>Complying with legal obligations</li>
            <li>Enforcing our Terms & Conditions</li>
            <li>Protecting against fraudulent activities</li>
          </ul>
          <p>We may also use your personal data for research and statistical purposes, but we will always anonymize the data before using it for these purposes.</p>
        </div>

        {/* Legal Basis for Processing */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Legal Basis for Processing</h2>
          <p>
            We process your personal data based on the following legal grounds:
          </p>
          <ul className="list-disc ml-8 mb-4">
            <li>Performance of a contract: We process your personal data to fulfill our contractual obligations to you, such as providing gym buddy matching services and personalized diet and training plans.</li>
            <li>Legitimate interests: We process your personal data to pursue our legitimate interests, such as improving our App and services and communicating with you about our products and services.</li>
            <li>Consent: We process your personal data based on your consent, such as when you provide us with your contact information to receive marketing communications.</li>
          </ul>
          <p>Details about each legal basis...</p>
        </div>

        {/* Sharing Your Personal Data */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Sharing Your Personal Data</h2>
          <p>
            We may share your personal data with the following third parties:
          </p>
          <ul className="list-disc ml-8 mb-4">
            <li>Service providers: We may share your personal data with third-party service providers who help us provide our App and services, such as payment processors and customer support providers.</li>
            <li>Business partners: We may share your personal data with business partners who offer complementary products or services.</li>
            <li>Legal authorities: We may share your personal data with law enforcement or other legal authorities if required by law or to protect our legal rights.</li>
          </ul>
          <p>We may also share your personal data with third parties if we sell or transfer all or a portion of our business or assets.</p>
        </div>

        {/* Transferring Your Personal Data */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Transferring Your Personal Data</h2>
          <p>
            We may transfer your personal data to countries outside of the European Economic Area (EEA) that may not provide the same level of data protection as your home country. In such cases, we will ensure that appropriate safeguards are in place to protect your personal data, such as standard contractual clauses approved by the European Commission.
          </p>
        </div>

        {/* Data Subject Rights */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Data Subject Rights</h2>
          <p>
            As a data subject, you have the following rights regarding your personal data:
          </p>
          <ul className="list-disc ml-8 mb-4">
            <li>Right to access: You have the right to request access to your personal data and receive a copy of it.</li>
            <li>Right to rectification: You have the right to request that we correct any inaccuracies in your personal data.</li>
            <li>Right to erasure: You have the right to request that we delete your personal data.</li>
            <li>Right to restrict processing: You have the right to request that we restrict the processing of your personal data.</li>
            <li>Right to data portability: You have the right to receive your personal data in a structured, commonly used, and machine-readable format and to transmit it to another controller.</li>
            <li>Right to object: You have the right to object to the processing of your personal data for certain purposes, such as direct marketing</li>
            <li>Right to withdraw consent: If we process your personal data based on your consent, you have the right to withdraw your consent at any time.</li>
          </ul>
        </div>

        {/* Cookies and Other Tracking Technologies */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Cookies and Other Tracking Technologies</h2>
          <p>
            Our App uses cookies and similar tracking technologies to enhance functionality and performance. For detailed information about the cookies we use, please refer to our Cookie Policy.
          </p>
        </div>

        {/* Children's Privacy */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Children's Privacy</h2>
          <p>
            Our App is intended for adults aged 18 years old and above. We do not intentionally collect personal data from individuals under the age of 18. Parents or guardians who become aware that their child has provided us with personal data without their consent should contact us immediately.
          </p>
        </div>

        {/* Security Measures */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Security Measures</h2>
          <ul className="list-disc ml-8 mb-4">
            <li>Encryption: We use encryption protocols to protect data in transit and at rest, ensuring the confidentiality and integrity of your information.</li>
            <li>Access Controls: Strict access controls are implemented to limit access to personal information, ensuring that only authorized personnel have access.</li>
            <li>Security Audits: Regular security audits and assessments are conducted to identify and address potential vulnerabilities in our systems.</li>
          </ul>
          <p>
              Notwithstanding anything stated above, no electronic transmission or storage method is completely secure, and we cannot guarantee absolute security.
          </p>
        </div>

        {/* Updates to this Privacy Policy */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Updates to this Privacy Policy</h2>
          <p>
            We reserve the right to update this Privacy Policy at any time. Your continued use of our App after any such updates will constitute your acceptance of the revised Privacy Policy.
          </p>
        </div>

        {/* Contact Us */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
          <p>
            For any questions or concerns about our Privacy Policy or our data practices, please contact us at [insert contact information].
          </p>
        </div>

        {/* Governing Law */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
          <p>
            This Privacy Policy is governed by and construed in accordance with the laws of India. Disputes are subject to the exclusive jurisdiction of the competent courts in India.
          </p>
        </div>

        {/* Conclusion */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-2">Conclusion</h2>
          <p>
            We hope that this Privacy Policy has provided you with a clear understanding of how we collect, use, and protect your personal data. If you have any questions or concerns, please do not hesitate to contact us.
          </p>
        </div>
    </div>
  );
}

export default PPPage;